import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
// Interceptor
import { JwtInterceptor } from './core/_helpers/jwt.interceptor';
// Module
import { AppRoutingModule } from './app-routing.module';
// Components
import { AppComponent } from './app.component';
import { VideoComponent } from './video';
// Services
import { APIURL } from './services';
// Pipe
import { SafeHtmlPipe } from './pipes';

@NgModule({
	declarations: [AppComponent, VideoComponent],
	imports: [BrowserModule, HttpClientModule, AppRoutingModule, SafeHtmlPipe],
	providers: [
		APIURL,
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
